import { render } from "./travel_cerificat.vue?vue&type=template&id=1482589b"
const script = {}
script.render = render

export default script